<template>
  <section class="check-displayer-container">
    <div class="displayer-layout">
      <i class="pi pi-times" @click="$emit('close')"></i>

      <div class="actions">
        <button class="btn capture-btn" @click="$emit('capture')">
          <SvgIcon name="cameraOutlined" size="24" />
          <span>__('Capture again')</span>
        </button>

        <button class="btn delete-btn" @click="$emit('remove')">
          <SvgIcon name="trashOutlined" size="24" />
          <span>__('Delete check')</span>
        </button>
      </div>
      <div class="rotate-wrapper" :class="{ rotate: isRotated }">
        <div
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
          class="check-img-wrapper"
          :class="{ rotate: isRotated, 'slide-out': isSliding }"
        >
          <transition name="fade" mode="out-in">
            <img
              :key="currImgOrient"
              :src="imgUrls[currImgOrient]"
              alt="check"
            />
          </transition>
        </div>
        <button class="btn return-btn" @click="switchImg">
          <SvgIcon name="return" size="18" />
          <span>__('Flip image')</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon.vue'

export default {
  name: 'CheckDisplayer',
  emits: ['close', 'capture', 'remove'],
  components: {
    SvgIcon,
  },
  props: {
    check: Object,
    index: Number,
    imgUrls: Object,
    imgOrient: String,
  },
  created() {
    this.currImgOrient = this.imgOrient
  },
  data() {
    return {
      isRotated: false,
      currImgOrient: 'front',
      touchStartX: 0,
      touchEndX: 0,
      touchStartY: 0,
      touchStartTime: 0,
      isSliding: false,
    }
  },
  methods: {
    captureCheck(check, index) {
      this.$emit('capture', check, index)
    },
    switchImg() {
      this.isSliding = true
      setTimeout(() => {
        if (this.currImgOrient === 'front') {
          this.currImgOrient = 'rear'
        } else {
          this.currImgOrient = 'front'
        }
        this.isSliding = false
      }, 400) // Increased duration for softer transition
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX
      this.touchStartY = event.touches[0].clientY
      this.touchStartTime = new Date().getTime()
    },
    handleTouchMove(event) {
      event.preventDefault()
    },
    handleTouchEnd(event) {
      const touchEndX = event.changedTouches[0].clientX
      const touchEndY = event.changedTouches[0].clientY
      const touchEndTime = new Date().getTime()

      const distanceX = touchEndX - this.touchStartX
      const distanceY = touchEndY - this.touchStartY
      const elapsedTime = touchEndTime - this.touchStartTime

      if (Math.abs(distanceX) > Math.abs(distanceY)) {
        const swipeThreshold = 50
        const timeThreshold = 300

        if (
          Math.abs(distanceX) > swipeThreshold &&
          elapsedTime < timeThreshold
        ) {
          this.switchImg()
        }
      }
    },
    rotateImg() {
      this.isRotated = !this.isRotated
    },
  },
}
</script>

<style lang="scss" scoped>
.check-displayer-container {
  // Your existing styles here

  .check-img-wrapper {
    transition: transform 0.145s cubic-bezier(0.45, 0, 0.55, 1);

    &.slide-out {
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.145s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  // Add any other existing styles you had here
}
</style>
